// components/SafetyCompliance.jsx
import React from "react";
import { Box, Paper, Typography, Stack, alpha, useTheme } from "@mui/material";
import { Security } from "@mui/icons-material";
import CustomCheckbox from "../../../../components/CustomForm/CustomCheckbox";

const SafetyCompliance = ({ formData, handleCheckBox }) => {
  const theme = useTheme();

  const items = [
    { label: "Allow Photos", name: "allow_photos", desc: "Enable image evidence" },
    { label: "Share with Family", name: "share_with_family", desc: "Update family portal" },
    { label: "Mandatory Notes", name: "mandatory_notes", desc: "Required visit notes" },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "10px",
        border: "1px solid #E2E8F0",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: 2.5,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          bgcolor: "#F0F7FF",
          borderBottom: "1px solid #E2E8F0",
        }}
      >
        <Security sx={{ color: "#2196F3", fontSize: 18 }} />
        <Typography variant="subtitle2" fontWeight={700} color="#1A3E72">
          Safety & Compliance
        </Typography>
      </Box>

      <Box sx={{ p: 2.5 }}>
        <Stack spacing={1.5}>
          {items.map((item) => (
            <Box
              key={item.name}
              sx={{
                p: 1.5,
                borderRadius: "6px",
                border: "1px solid #E2E8F0",
                bgcolor: formData[item.name] ? alpha(theme.palette.primary.main, 0.02) : "#FAFBFC",
              }}
            >
              <CustomCheckbox
                label={
                  <Box>
                    <Typography variant="body2" fontWeight={600} color="#1A1A2E">
                      {item.label}
                    </Typography>
                    <Typography variant="caption" color="#6B7280" sx={{ fontSize: "0.65rem" }}>
                      {item.desc}
                    </Typography>
                  </Box>
                }
                name={item.name}
                checked={formData[item.name] || false}
                onClick={(c) => handleCheckBox(item.name, c)}
              />
            </Box>
          ))}
        </Stack>
      </Box>
    </Paper>
  );
};

export default SafetyCompliance;